import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "@/lib/drivers/tandem/TandemTypes";
import { cz } from "@/utils/zodUtils";

export type DailyBasalPayload = {
  daily_total_basal: number;
  last_basal_rate?: number;
  iob?: number;
  actual_battery_charge?: number;
  lipo_mv?: number;
};

export type DailyBasalEvent = {
  dailyTotalBasal: number;
  lastBasalRate?: number;
  iob?: number;
  actualBatteryCharge?: number;
  lipoMv?: number;
};

const dailyBasalSchema = z.object({
  daily_total_basal: z.number(),
  last_basal_rate: cz.permissive(z.number()),
  iob: cz.permissive(z.number()),
  actual_battery_charge: cz.permissive(z.number()),
  lipo_mv: cz.permissive(z.number()),
});

export const LID_DAILY_BASAL = {
  value: 0x51,
  name: "Daily Basal Event",
  format: "fff.bh",
  fields: ["daily_total_basal", "last_basal_rate", "iob", "actual_battery_charge", "lipo_mv"],
  postprocess: rec => ({
    dailyTotalBasal: rec.daily_total_basal,
    lastBasalRate: rec.last_basal_rate,
    iob: rec.iob,
    actualBatteryCharge: rec.actual_battery_charge,
    lipoMv: rec.lipo_mv,
  }),
  schema: dailyBasalSchema,
} as const satisfies TandemEventDefinition<DailyBasalPayload, DailyBasalEvent>;
